import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { RelatedToType } from '@shared/enums';
import { FieldDef, QueryConfig } from '@core/models';
import { getAllowedFields } from '@shared/functions';
import { FJSON, guid } from '@shared/Utils/common.utils';

@Component({
  selector: 'add-chart',
  templateUrl: './add-chart.component.html',
  styleUrls: ['./add-chart.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddChartComponent implements OnInit {
  addContactForm: UntypedFormGroup;
  copyFields: { cc: boolean; bcc: boolean };
  message: any;
  fieldDefs: Array<FieldDef>;
  parsedFilters: Partial<QueryConfig.ChartFilters>;

  private _internalFilterState: { fjson: string };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<AddChartComponent>,
    private readonly _formBuilder: UntypedFormBuilder,
  ) {
    this.message = null;
    this.copyFields = {
      cc: false,
      bcc: false,
    };
  }

  ngOnInit(): void {
    this.addContactForm = this._formBuilder.group({
      title: ['', [Validators.required]],
      chart_type: ['', [Validators.required]],
      summary_value: [''],
      summary_type: ['', [Validators.required]],
      group_by: [''],
      series_value: [''],
    });

    this.fieldDefs = getAllowedFields(this.data.fieldDefs, RelatedToType.Project);

    if (this.data.chart) {
      this.addContactForm.patchValue(this.data.chart);
      if (this.data.chart.filters) {
        this.parsedFilters = JSON.parse(this.data.chart.filters);
      }
    }
  }

  saveAndClose(): void {
    let chart = this.addContactForm.getRawValue();

    if (!chart.title?.trim().length) {
      chart.title = 'Untitled';
    }

    if (chart.summary_type == 'total') {
      chart.summary_value = 'id';
    }
    chart.filters = JSON.stringify(this._internalFilterState);
    chart.data = {};
    if (!chart.id) {
      chart.id = guid();
    }
    this.matDialogRef.close({ chart: chart });
  }

  discard(): void {
    this.matDialogRef.close();
  }

  noop(event: any): void {}

  filterChanged({ filters }: { filters: any[] }): void {
    this._internalFilterState = {
      fjson: FJSON(
        filters.map(({ id: name, filter: operator, value, alternate_value }) => ({
          name,
          operator,
          value: alternate_value ? [alternate_value] : value,
        })),
      ),
    };
  }
}
